import { AddFundsUpgradeRoute } from 'types/add-funds';
import { UpgradeMetadata } from 'types/upgrade';

export const addFundsUpgradeRouteOrder: Array<AddFundsUpgradeRoute> = [
	'upgrade-landing',
	'add-funds-ria-amount',
	'upgrade-core-plans',
	'upgrade-plus-plans',
	'upgrade-accreditation',
	'upgrade-view-allocation',
	'add-funds-ria-agreements',
	'add-funds-ria-review',
	'add-funds-ria-success',
	'upgrade-success'
];

export const upgradeMetadata: UpgradeMetadata = {
	BASIC: {
		upgradeImagePath: '/images/service-level/basic-upgrade-icon-large.png',
		upgradePerks: [
			{
				boldText: 'The Fundrise iPO',
				plainText: ' - get potential access to invest'
			},
			{
				boldText: 'Investor goals',
				plainText: ' - add a personal investing goal to your account'
			}
		]
	},
	CORE: {
		upgradeImagePath: '/images/service-level/core-upgrade-icon-large-120818.png',
		upgradePerks: [
			{
				boldText: 'Customized plans',
				plainText: ' based on your investment objective'
			},
			{
				boldText: 'Diversification',
				plainText: ' across dozens more real estate projects'
			}
		]
	},
	ADVANCED: {
		upgradeImagePath: '/images/service-level/core-upgrade-icon-large-120818.png'
	},
	PREMIUM: {
		upgradeImagePath: '/images/service-level/premium-upgrade-icon-large.png',
		upgradePerks: [
			{
				boldText: 'Priority support from our team',
				plainText: ' when you have questions'
			},
			{
				boldText: 'Ability to schedule a call',
				plainText: ' with one of our knowledgeable team members*'
			},
			{
				boldText: '365 days of advisory fees waived',
				plainText: ' for each friend who joins Fundrise**'
			}
		]
	}
};
